import { ProfileMenu } from '~domains/account';

import { ScreenHeader, ScreenHeaderProps } from '~shared/ui/screen';

export const PartnerApplicationMenuHeader = (props: ScreenHeaderProps) => {
  return (
    <ScreenHeader {...props} rightSlot={<ProfileMenu />} logoAlign="left" />
  );
};
